var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2005,
    height: 1571,
    viewBox: "0 0 2005 1571",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M743.757 1261.91C1055.93 1502.15 1540.59 1549.93 1761.83 1430.41C1969.42 1318.27 1993.62 1119.72 1872.33 920.625C1711.46 656.596 1874.82 450.512 1704.28 248.238C1588.86 111.364 1139.59 38.693 800.915 243.906C467.281 446.055 302.945 922.661 743.779 1261.92L743.757 1261.91Z",
    fill: "#EADEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.873 638.364C245.679 359.029 473.055 155.662 656.908 162.892C829.391 169.677 954.61 301.792 1003.71 485.22C1068.82 728.457 1271.34 817.293 1296.4 1020.14C1313.36 1157.45 1118.67 1366.07 824.562 1339.2C534.866 1312.83 178.584 1032.85 217.873 638.364Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.678 733.992C179.94 448.04 348.637 211.189 516.388 193.04C673.762 176.004 811.14 292.119 888.989 470.534C992.252 707.17 1191.73 768.76 1251.39 970.2C1291.74 1106.52 1153.57 1344.16 882.492 1357.77C615.526 1371.2 242.059 1137.75 205.678 733.992Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack2);
export default __webpack_public_path__ + "static/media/back2.8f4494ab7edefb9acba6c8a99ce601f4.svg";
export { ForwardRef as ReactComponent };